import { render, staticRenderFns } from "./serviceBox.vue?vue&type=template&id=602e8e82&"
import script from "./serviceBox.vue?vue&type=script&lang=js&"
export * from "./serviceBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports